import { AnyAction } from 'redux';
import { Actions } from '../../Actions/Profile/Types';
import {  IPage, IProfile } from '../../Models/Security';

export interface IProfileState {

	isRequest: boolean;
	page: IPage<IProfile>;
	current?: IProfile;
	faenas: any[];
}

const initialState = {
	isRequest: false,
	page: {
		meta: {
			total: 0,
			page: 0,
			size: 0,
			pages: 0
		},
		data: []
	},
	current: undefined,
	faenas: []
};

const asyncReducer = (
	state: IProfileState = initialState,
	action: AnyAction
) => {
	switch (action.type) {
		case Actions.REQUESTING_PROFILE:
			return {...state, isRequest: !state.isRequest };
		case Actions.FETCH_PROFILE:
			const profile = action.payload as IProfile;
			return {...state, current: profile };
		case Actions.FETCH_PROFILE_LIST:
			const pageFetch = action.payload as IPage<IProfile>;
			return {...state, page: pageFetch };
	}
	return state;
};

export default asyncReducer;
